module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=AU - Australia.75ed4514.svg";